module.exports = __webpack_public_path__ + "img/instagram.eaaeaab4.svg";